import React, { ChangeEvent, forwardRef } from 'react';
import classnames from 'classnames';

export interface SwitchProps {
  testId?: string;
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  size?: 'sm';
  type?: 'light' | 'dark';
  id: string;
  name: string;
  value?: string | number;
  defaultChecked?: boolean;
  controlling?: boolean;
  checked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

// eslint-disable-next-line react/display-name
const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      testId,
      type = 'light',
      size,
      id,
      name,
      color,
      value,
      defaultChecked,
      controlling,
      onChange,
      checked,
      ...props
    }: SwitchProps,
    ref,
  ) => (
    <div
      data-testid={testId}
      className={classnames('switch', {
        'switch-sm': size == 'sm',
        [`switch-${color}`]: color,
      })}
    >
      <input
        ref={ref}
        {...props}
        type="checkbox"
        className="switch-checkbox"
        id={id || name}
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        checked={checked}
        {...(controlling && {
          onChange: onChange,
        })}
      />
      <label
        className={classnames(`switch-label switch-label-${type}`)}
        htmlFor={id || name}
      />
    </div>
  ),
);

export default Switch;
